import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import styles from './BackButtonHeader.module.scss';
import ICONS from '../../static/media/icons/icons-helper';

const BackButtonHeader = ({ title }) => {
  const history = useHistory();

  return (
    <div className={styles.headerContainer}>
      <div className={styles.linkText} onClick={history.goBack}>
        <img
          className={styles.arrowIcon}
          src={ICONS.CHEVRON_LEFT}
          alt="logo-img"
        />
        {(title !== '' && title) || 'BACK'}
      </div>
    </div>
  );
};

BackButtonHeader.propTypes = {
  title: PropTypes.string,
};

BackButtonHeader.defaultProps = {
  title: '',
};

export default BackButtonHeader;
